import React, { memo } from 'react';

import { Label } from './styles';

interface IComponentProps {
  label: string | React.ReactNode;
}

const SelectLabel: React.FC<IComponentProps> = ({ label }) => {
  return <Label>{label}</Label>;
};

export default memo(SelectLabel);
